import dayjs from "dayjs";
import { MAX_SNOOZE_DAYS, MIN_SNOOZE_DAYS } from "./constants";

const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

export const calculateDaysFromDate = (date) => {
  if (!date) return 0;
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Reset time to start of day
  const selectedDateStart = new Date(date);
  selectedDateStart.setHours(0, 0, 0, 0); // Reset time to start of day
  const diffTime = selectedDateStart.getTime() - today.getTime();
  const diffDays = Math.ceil(diffTime / MILLISECONDS_PER_DAY);
  return diffDays;
};

export const validateSelectedDate = (date) => {
  const days = calculateDaysFromDate(date);
  return days >= MIN_SNOOZE_DAYS && days <= MAX_SNOOZE_DAYS;
};

export const getFinalPeriodDays = (durationMode) => {
  switch (durationMode.type) {
    case "date":
      return calculateDaysFromDate(durationMode.selectedDate);
    default:
      return durationMode.value;
  }
};

export const getMinDateString = () => {
  return new Date(Date.now() + MILLISECONDS_PER_DAY)
    .toISOString()
    .split("T")[0];
};

export const getMaxDateString = () => {
  return new Date(Date.now() + MAX_SNOOZE_DAYS * MILLISECONDS_PER_DAY)
    .toISOString()
    .split("T")[0];
};

// Dayjs versions for MUI DatePicker
export const getMinDateDayjs = () => {
  return dayjs().add(1, "day");
};

export const getMaxDateDayjs = () => {
  return dayjs().add(MAX_SNOOZE_DAYS, "day");
};

export const isFormValid = (durationMode, reasonMode) => {
  // Check duration validity
  const isDurationValid =
    (durationMode.type === "preset" && durationMode.value > 0) ||
    (durationMode.type === "date" &&
      durationMode.selectedDate &&
      validateSelectedDate(durationMode.selectedDate));

  // Check reason validity
  const isReasonValid =
    (reasonMode.type === "preset" && reasonMode.value !== "") ||
    (reasonMode.type === "custom" && reasonMode.customValue.trim() !== "");

  return isDurationValid && isReasonValid;
};
